export const editMutations = <const>{
	SKLAD_OV_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'SKLAD_OV_NAKLADOVE_STREDISKO_SELECT_MAPPER',
};
